import * as React from 'react'
import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { ChevronRight } from 'lucide-react'
import { cn } from '../../../_shared/lib'

type UsecaseTableAccordionProps = {
  summary: React.ReactNode
  children: React.ReactNode
  defaultExpanded?: boolean
  disabled?: boolean
}

export function UsecaseTableAccordion({ summary, children, defaultExpanded, disabled }: UsecaseTableAccordionProps) {
  return (
    <AccordionPrimitive.Root type="single" collapsible defaultValue={defaultExpanded ? 'item-1' : undefined} disabled={disabled} className="border-b">
      <AccordionPrimitive.Item value="item-1" className="border-0">
        <AccordionPrimitive.Header className="flex">
          <AccordionPrimitive.Trigger
            className={cn(
              'flex flex-1 items-center justify-start gap-2 py-3 text-sm font-medium transition-all',
              'hover:bg-gray-50',
              'min-h-[48px]',
              '[&[data-state=open]>svg]:rotate-90',
              disabled && 'pointer-events-none opacity-50',
            )}
          >
            <span className="text-sm">{summary}</span>
            <ChevronRight className="h-4 w-4 shrink-0 transition-transform duration-200" />
          </AccordionPrimitive.Trigger>
        </AccordionPrimitive.Header>
        <AccordionPrimitive.Content className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
          <div className="pt-0 pb-4">{children}</div>
        </AccordionPrimitive.Content>
      </AccordionPrimitive.Item>
    </AccordionPrimitive.Root>
  )
}
